import React from "react";
import { I18n } from "@aws-amplify/core";
import { get, filter, includes } from "lodash";

import { formatDuration } from "../../../utils/date";
import { remainingPolicyTime } from "../../../utils/policies";

const DataPrivacyCompliance = (props) => {
  const { policy, acceptances } = props;

  const acceptance = get(
    filter(
      acceptances,
      (a) => get(a, ["policy", "id"]) === get(policy, ["id"])
    ),
    [0]
  );

  let compliance = "";

  if (get(policy, ["compliance", "compliance"]) === "optional") {
    compliance = I18n.get("profiles_optional");
  } else if (includes([true, false], get(acceptance, ["accepted"]))) {
    compliance = I18n.get("profiles_required");
  } else if (get(policy, ["compliance", "compliance-deferral"]) === "0") {
    compliance = I18n.get("profiles_requiredNow");
  } else {
    const remainingTime = remainingPolicyTime(policy);
    if (remainingTime === 0) {
      compliance = I18n.get("profiles_requiredNow");
    } else {
      compliance = `${formatDuration(
        Math.round(remainingTime / 1000)
      )} ${I18n.get("profiles_left")}`;
    }
  }

  return <span>{compliance}</span>;
};

export default DataPrivacyCompliance;
